import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { SessionStorageService } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';
import { AppConstants } from '../constant'

@Injectable({
  providedIn: 'root'
})
export class ReferralsService {

  constructor(private http: Http, private session: SessionStorageService,private cookieService: CookieService) { }
  referrals() {
    return new Promise((resolve, reject) => {
      const url = AppConstants.baseUrl+'directsponsorreport.asp';
      const headers = new Headers();
      headers.append("Authorization", this.session.retrieve("token"));
      const option = new RequestOptions({ headers: headers });
      this.http.get(url, option).subscribe((res: any) => {
        const response = JSON.parse(res._body);
        if(response.status=='Success') {
          resolve(response);
        } else { reject(response); }
      });
    });
  }
  getreferralid() {
    return new Promise((resolve, reject) => {
      const url = AppConstants.baseUrl+'getaffiliatelink.asp';  
      const headers = new Headers();
      headers.append("Authorization", this.session.retrieve("token"));
      const option = new RequestOptions({ headers: headers });
      this.http.get(url, option).subscribe((res: any) => {
        const response = JSON.parse(res._body);
        if(response.status=='success') {
          resolve(response);
        } else { reject(response); }
      });
    });
  }
}
